<div class="flex flex-row group">
    <a [href]="item" target="_blank" class="text-primary text-wrap w-80">
        {{ item}}
    </a>
    <div (mouseenter)="onHover(true)" (mouseleave)="onHover(false)" (click)="copyToClipboard(item)"
        class="transform opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer">
        @if (!isCopied()) {
        <span><i class="fa-regular fa-copy text-primary"></i></span>
        } @else {
        <span><i class="fa-solid fa-check text-primary"></i></span>
        }
    </div>
</div>